<template>
  <v-autocomplete
    :items="optionEntityListFormatted"
    :loading="loading"
    :rules="[validateHasValue]"
    :value="value"
    @input="value => $emit('input', value)"
    chips
    clearable
    deletable-chips
    multiple
    outlined
    required
  ></v-autocomplete>
</template>

<script>
import selectFkMixin from "./selectFkMixin";

export default {
  mixins: [selectFkMixin],
  props: {
    value: {
      default: () => [],
    },
  },
};
</script>
